export default "__VITE_ASSET__67ec7174__"